<template>
  <div style="padding: 0 20px 20px">
    <!-- 汇总信息 -->
    <el-descriptions :column="4" size="small" border style="margin-bottom:14px">
      <el-descriptions-item label="老人">{{ sppRow.person_name }}</el-descriptions-item>
      <el-descriptions-item label="电话">{{ sppRow.person_phone }}</el-descriptions-item>
      <el-descriptions-item label="地址">{{ sppRow.home_address }}</el-descriptions-item>
      <el-descriptions-item label="服务进度">
        <el-progress :percentage="progressPct"
                     :format="() => `${sppRow.generated_count}/${sppRow.total_count}`"
                     :status="sppRow.generated_count >= sppRow.total_count ? 'success' : ''"
                     style="width:120px;display:inline-block"></el-progress>
      </el-descriptions-item>
    </el-descriptions>

    <!-- 服务单列表 -->
    <el-table v-loading="loading" :data="tableData" border style="width:100%" size="small">
      <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
      <el-table-column label="计划服务日期" min-width="120" align="center">
        <template slot-scope="scope"><span>{{ scope.row.plan_date }}</span></template>
      </el-table-column>
      <el-table-column label="实际完成时间" min-width="150" align="center">
        <template slot-scope="scope"><span>{{ scope.row.actual_date || '—' }}</span></template>
      </el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" type="warning" size="mini">待处理</el-tag>
          <el-tag v-else-if="scope.row.status === 1" type="success" size="mini">已完成</el-tag>
          <el-tag v-else-if="scope.row.status === 2" type="info" size="mini">已取消</el-tag>
          <el-tag v-else size="mini">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="服务提供商" min-width="120" align="center">
        <template slot-scope="scope"><span>{{ scope.row.supplier_name || '—' }}</span></template>
      </el-table-column>
      <el-table-column label="服务人员" min-width="90" align="center">
        <template slot-scope="scope"><span>{{ scope.row.supplier_person_name || '—' }}</span></template>
      </el-table-column>
      <el-table-column label="备注" min-width="120" align="center" show-overflow-tooltip>
        <template slot-scope="scope"><span>{{ scope.row.remark || '—' }}</span></template>
      </el-table-column>
    </el-table>
    <div style="margin-top:10px;text-align:center">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage" :page-sizes="[10, 20, 50]"
                     :page-size="pageSize" layout="total, sizes, prev, pager, next" :total="totalCells">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { querypersonservicepackageorders } from '../../../api/serviceMark'

export default {
  name: 'servicePackageOrders',
  props: {
    sppRow: {
      type: Object,
      default: () => ({})
    },
    packageRow: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      totalCells: 0
    }
  },
  computed: {
    progressPct () {
      if (!this.sppRow.total_count || this.sppRow.total_count === 0) return 0
      return Math.min(100, Math.round((this.sppRow.generated_count / this.sppRow.total_count) * 100))
    }
  },
  created () {
    this.loadOrders()
  },
  methods: {
    loadOrders () {
      this.loading = true
      let params = { page: this.currentPage, size: this.pageSize }
      let data = { spp_id: this.sppRow.id }
      querypersonservicepackageorders(params, data).then(res => {
        this.tableData = res.data.list || []
        this.totalCells = res.data.cnt || 0
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.loadOrders()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.loadOrders()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/childComponents/servicePackageOrders.vue